import { LaasClientId, loggerConfig, MyHRLogger } from '@amzn/myhr-ui-commons/dist';
import { MetricEvents, MetricUnits } from '@amzn/myhr-livehelp-ui';

export const myHRLogger = new MyHRLogger(loggerConfig);

/**
 * This method is used to emit various metrics in FAB, purpose of this method is to
 * emit ServiceName as 'LiveHelpServiceInline', emit clientId and pageName according to the arguments passed.
 * This is different from livehelp 'recordMetrics', as there we take pageName and clientId from DOM.
 * @param operationName - operationName for metric
 * @param serviceName - serviceName for metric
 * @param clientId - clientId passed
 * @param pageName - pageName passed
 * @param metricName -  Metric name: may be count, error-count etc
 */
export const recordMetricForFab = (
  operationName: string,
  serviceName: string,
  clientId: LaasClientId,
  pageName: string,
  metricName: MetricEvents,
) => {
  const metricDimensionsList: any = [];
  metricDimensionsList.push(getDimensions(operationName, serviceName, clientId, pageName));
  metricDimensionsList.push(getDimensions(operationName, serviceName));

  metricDimensionsList.forEach((metricDimension) => {
    myHRLogger.logEmfMetric({
      metricName,
      dimensions: metricDimension,
      metricUnit: MetricUnits.COUNT,
      metricValue: 1,
    });
  });
};

/**
 * This method returns dimensionMap on basis of arguments passed.
 * @param operationName - operationName for metric
 * @param serviceName - serviceName for metric
 * @param clientId - clientId passed
 * @param pageName - pageName passed
 */
export const getDimensions = (
  operationName: string,
  serviceName: string,
  clientId?: LaasClientId,
  pageName?: string,
) => {
  if (clientId && pageName) {
    return [
      {
        operation: operationName,
        serviceName,
        clientId,
        pageName,
      },
    ];
  }
  return [
    {
      operation: operationName,
      serviceName,
    },
  ];
};
